import { NameDto } from './NameDto'
import { PlatformTypeEnum } from './PlatformTypeEnum'

export enum RebateApprovalStatus {
  New = 1,
  Pending = 2,
  Approved = 3,
  Rejected = 4,
  Failed = 5,
  Reversed = 6,
}

export const rebateApprovalEditableStatuses = [
  RebateApprovalStatus.New,
  RebateApprovalStatus.Failed,
]

export interface RebateApprovalSummary {
  approvalsTotalCommission: number
  rebatesToApprove: number
  paidRebates: number
}

export interface IntroducingBrokerRebateApprovalDto {
  id: string
  tradingAccount: NameDto<string>
  tradingAccountType: NameDto<PlatformTypeEnum>
  rebateGroup: NameDto<string> | null
  accumulatedVolumeFxm: number
  accumulatedVolumeOther: number
  accumulatedCommission: number
  rebateAmount: number
  status: NameDto<RebateApprovalStatus>
  showNotification: boolean
}

export interface IBRebateSingleApprovalResponseDto {
  id: string
  maxAllowedPercentage: number
  status: NameDto<number>
}

export interface IBRebateBulkApprovalResponseDto {
  processed: string[]
  skipped: string[]
}

export type IBRebateApprovalSortKeysDto =
  | 'tradingAccountName'
  | 'accountType'
  | 'groupName'
  | 'accumulatedVolumeFxm'
  | 'accumulatedVolumeOther'
  | 'accumulatedCommission'
  | 'rebateAmount'
  | 'rebatePayoutStatusId'
  | 'showNotification'
